import { createReducer, on } from '@ngrx/store';
import { LeaseDTO } from '../../model/lease.model';
import * as LeaseActions from '../actions/lease.action';

export const leaseFeatureKey = 'lease';

export interface LeaseState {
  leases: LeaseDTO[];
  loading: boolean;
  error: any;
  fileLoading: boolean;
  fileError: any;
}

export const initialState: LeaseState = {
  leases: [],
  loading: false,
  error: null,
  fileLoading: false,
  fileError: null,
};

export const leaseReducer = createReducer(
  initialState,
  on(LeaseActions.loadLeases, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(LeaseActions.loadLeasesSuccess, (state, { leases }) => ({
    ...state,
    leases,
    loading: false,
    error: null,
  })),
  on(LeaseActions.loadLeasesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(LeaseActions.createLease, LeaseActions.updateLease, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(LeaseActions.createLeaseSuccess, (state, { lease }) => ({
    ...state,
    leases: [...state.leases, lease],
    loading: false,
    error: null,
  })),
  on(LeaseActions.updateLeaseSuccess, (state, { lease }) => ({
    ...state,
    leases: state.leases.map(l => (l.id === lease.id ? lease : l)),
    loading: false,
    error: null,
  })),
  on(LeaseActions.createLeaseFailure, LeaseActions.updateLeaseFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(LeaseActions.uploadLeaseFile, LeaseActions.updateLeaseFile, LeaseActions.viewLeaseFile, LeaseActions.downloadLeaseFile, state => ({
    ...state,
    fileLoading: true,
    fileError: null,
  })),
  on(
    LeaseActions.uploadLeaseFileSuccess,
    LeaseActions.updateLeaseFileSuccess,
    LeaseActions.viewLeaseFileSuccess,
    LeaseActions.downloadLeaseFileSuccess,
    state => ({
      ...state,
      fileLoading: false,
      fileError: null,
    }),
  ),
  on(
    LeaseActions.uploadLeaseFileFailure,
    LeaseActions.updateLeaseFileFailure,
    LeaseActions.viewLeaseFileFailure,
    LeaseActions.downloadLeaseFileFailure,
    (state, { error }) => ({
      ...state,
      fileLoading: false,
      fileError: error,
    }),
  ),
);
